/**
 * Platform detection utilities for web/desktop environment branching.
 *
 * Extension point: when local AI sidecar or local LLM support is added,
 * additional platform capabilities can be detected and exposed here.
 */

export const isDesktop: boolean =
  typeof window !== 'undefined' && '__TAURI_INTERNALS__' in window;

export const isWeb: boolean = !isDesktop;

/**
 * 모바일 뷰포트 판정 기준 너비(px). design-system `breakpoints.mobile`
 * (768px) 과 일치시킨다. 디자인 시스템 토큰을 직접 import 하지 않는 이유는
 * workspace-utils 가 디자인 레이어에 의존하지 않도록 하기 위함이며, 값이
 * 바뀌면 양쪽을 함께 갱신한다.
 */
export const MOBILE_BREAKPOINT_PX = 768;

/**
 * 현재 뷰포트가 모바일 폭(<= {@link MOBILE_BREAKPOINT_PX}px) 인지 동기적으로
 * 판정한다. `window` 가 없는 환경(SSR/prerender)에서는 데스크톱으로 간주해
 * `false` 를 돌려준다. 스토어 초기값/이펙트에서 가볍게 호출하기 위한 용도.
 */
export function isMobileViewport(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }
  return window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT_PX}px)`).matches;
}

export function getDesktopOS(): 'macos' | 'windows' | 'linux' | null {
  if (!isDesktop) return null;
  const ua = navigator.userAgent.toLowerCase();
  if (ua.includes('mac')) return 'macos';
  if (ua.includes('win')) return 'windows';
  if (ua.includes('linux')) return 'linux';
  return null;
}
